module.exports = __webpack_public_path__ + "static/media/02.4823b67f.png";